import React, { useEffect, useState } from 'react';
import ProjectCard from '../componets/ProjectCard';
import loadingImg from '../assets/undraw_clean_up_ucm0.svg';
const ProjectsPage = () => {
  const [projects, setProjects] = useState([]);
  const getProjects = async () => {
    const res = await fetch(
      'https://codesalley-api.herokuapp.com/api/projects',
      {
        method: 'GET',
        headers: {
          key: 'makemerich',
          'Contect-Type': 'application/json',
        },
      },
    );
    const data = await res.json();
    console.log(data)
    setProjects(data);
  };

  useEffect(() => {
    getProjects();
    return { getProjects, projects }
  }, [setProjects]);
  return (
    <div className={` project-container`}>
      <h2> Projects </h2>
      {projects.length < 1 ? (
        <div className="loading">
          {' '}
          <img src={loadingImg} alt="loading" />
        </div>
      ) : (
        <div className="grid-box ">
          {projects.map((ele) => (
            <ProjectCard key={ele.id} data={ele} />
          ))}
        </div>
      )}
    </div>
  );
};

export default ProjectsPage;



// WEBPACK FOOTER //
// ./src/pages/ProjectsPage.js